import * as React from "react";

const InputContainer = ({ handleDropAccepted, fileInputRef }) => (
  <p>
    <input 
      type="file" 
      ref={fileInputRef} 
      style={{display: "none"}} 
      onChange={(evt) => handleDropAccepted(evt.target.files)}
      accept="image/jpeg, image/png"
    />
    Drop or click to upload an image.
  </p>
);

export default InputContainer;


// WEBPACK FOOTER //
// ./src/modules/AdHocTools/VisualSearch/components/InputContainer.tsx